// extracted by mini-css-extract-plugin
export default {"wrapper":"Greeting_wrapper__XuD3C","heading":"Greeting_heading__YpWYy","sub":"Greeting_sub__lSrPl"};